import { useEffect, useState } from "react";

import { toast } from "react-hot-toast";
import Select from "react-select";
import { Button } from "react-bootstrap";

import {
  Details_Rest_Menu_Restaurant_Item_Customization_List_Get,
  Details_Restaurant_Item_Customization_List_Get,
  Save_Restaurant_Item_Customization_Post,
  Update_Rest_Menu_Restaurant_Item_Customization_Put,
  Update_Restaurant_Item_Customization_Put,
} from "api/ApiConst";
import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
  isAlphaNumercSpecialCharSpc,
  isAlphaNumericSpc,
  isEmpty,
} from "utils/TextUtils";
import { MODAL_LOADER } from "utils/constants";
import { API_SUCCESS } from "api/ResponseCodes";

import ModalWrapper from "components/common/ModalWrapper";
import MultiImageSelector from "./RestaurantMultiImageSelector";
import Cookies from "universal-cookie";

const customizationKeyValuePairs = [
  {
    label: "Single Selection",
    value: "Single Selection",
    key: "SingleSelection",
  },
  { label: "Multi Selection", value: "Multi Selection", key: "MultiSelection" },
  { label: "Fixed Selection", value: "Fixed Selection", key: "FixedSelection" },
];

const RestaurantItemCustomizationAddEdit = (props) => {
  const {
    show,
    hideModal,
    recordID,
    handleRefresh,
    restaurantKeyValuePairs,
    ownedItem,
  } = props;
  const defaultRecordObj = {
    // restaurantUuid: "",
    title: "",
    description: "",
    sortOrder: 1,
    customizationType: "",
    minimumSelection: 0,
    maximumSelection: 0,
    selectionNumber: 0,
  };

  const [record, setRecord] = useState({ ...defaultRecordObj });
  const [customizationOptions, setCustomizationOptions] = useState([
    {
      sequenceNumber: 0,
      title: "",
      price: 0,
      active: true,
      iconRefId: "",
      syncOnUrbanPiper: false,
    },
  ]);

  const currencyDetail = new Cookies().get("currencyDetail");
  useEffect(() => {
    if (recordID) {
      const rUrl = ownedItem
        ? Details_Restaurant_Item_Customization_List_Get
        : Details_Rest_Menu_Restaurant_Item_Customization_List_Get;
      callGetApi(
        MODAL_LOADER,
        rUrl.replaceAll("{recordID}", recordID),
        {},
        (response) => {
          if (response.errorCode === API_SUCCESS) {
            const res = response.responsePacket;
            handleSetInitialValues(res);
          } else {
            toast.error(response.message);
          }
        }
      );
    }
  }, [recordID]);

  const handleSetInitialValues = (response) => {
    // Todo >> // set Parent Category Key
    // const _selectedRestaurantUuid = restaurantKeyValuePairs.find((obj) => obj.key === response.restaurantUuid);

    // Set Customization Type
    const _selectedCustomizationType = customizationKeyValuePairs.find(
      (obj) => obj.key === response.customizationType
    );

    let recordObj = {
      ...response,
      // restaurantUuid: _selectedRestaurantUuid || "", ToDo
      customizationType: _selectedCustomizationType || "",
      selectionNumber:
        _selectedCustomizationType?.key === "FixedSelection"
          ? response.maximumSelection
          : 0,
      // sortOrder: record.sortOrder,
    };
    setRecord(recordObj);
    setCustomizationOptions(response?.customizationOptions);
  };

  //Text Change Event
  const handleTextChange = (e, options = null, index = null) => {
    const { id, value, type, checked } = e.target;
    if (id === "title" && value.length !== 0) {
      if (!isAlphaNumercSpecialCharSpc(value)) {
        return;
      }
    }
    if (id === "price" && value.length !== 0) {
      if (value.length > 7) {
        return;
      }
    }

    if (options === null) {
      if (type === "number") {
        setRecord((prev) => ({ ...prev, [id]: parseInt(value) }));
      } else {
        setRecord((prev) => ({ ...prev, [id]: value }));
      }
    } else {
      let _customizationOptions = [...customizationOptions];
      if (type === "number") {
        _customizationOptions[index] = {
          ..._customizationOptions[index],
          [id]: parseInt(value),
        };
      } else if (type === "checkbox") {
        _customizationOptions[index] = {
          ..._customizationOptions[index],
          [id]: checked,
        };
      } else {
        _customizationOptions[index] = {
          ..._customizationOptions[index],
          [id]: value,
        };
      }
      setCustomizationOptions(_customizationOptions);
    }
  };

  //Text Check Box Change
  const handleCheckBoxChange = (e, key, index) => {
    const { id, checked } = e.target;
    if (key !== null) {
      let _customizationOptions = [...customizationOptions];
      _customizationOptions[index] = {
        ..._customizationOptions[index],
        [id]: checked,
      };
      setCustomizationOptions(_customizationOptions);
    }
  };

  //Text Check Availabilities
  const handleSelectChange = (e, id) => {
    setRecord((prev) => ({ ...prev, [id]: e }));
  };

  // IMAGE CHANGE
  const handleImageChange = (imageRefId, index) => {
    let _customizationOptions = [...customizationOptions];
    _customizationOptions[index] = {
      ..._customizationOptions[index],
      iconRefId: imageRefId,
    };
    setCustomizationOptions(_customizationOptions);
  };

  // Add More Customization Options
  const handleAddMoreCustomizeOptions = () => {
    setCustomizationOptions([
      ...customizationOptions,
      {
        sequenceNumber: 0,
        title: "",
        price: 0,
        active: false,
        iconRefId: "",
        syncOnUrbanPiper: false,
      },
    ]);
  };

  // Remove Customization Options
  const handleRemoveOption = (index) => {
    let _customizationOptions = [...customizationOptions];
    _customizationOptions.splice(index, 1);
    setCustomizationOptions(_customizationOptions);
  };

  // Check validation
  const checkInputValidation = (recordObj) => {
    if (isEmpty(recordObj.title)) {
      toast.error(`Title must not be empty`, { id: "toast" });
      return false;
    } else if (recordObj.title.length > 100) {
      toast.error(`Title must not be more then 100 character.`, {
        id: "toast",
      });
      return false;
    } else if (isEmpty(recordObj.customizationType)) {
      toast.error(`Customization Type must not be empty`, { id: "toast" });
      return false;
    } else if (
      recordObj.customizationType === "FixedSelection" &&
      isEmpty(recordObj.selectionNumber)
    ) {
      toast.error(`Selection Number must not be empty`, { id: "toast" });
      return false;
    } else if (recordObj.selectionNumber < 0) {
      toast.error(`Selection Number must not be negative`, { id: "toast" });
      return false;
    }
    return true;
  };

  // check Validations for customize options
  const checkCustomizationValidation = () => {
    if (customizationOptions.length === 0) {
      toast.error("At least one Customization option must be add", {
        id: "toast",
      });
      return false;
    } else {
      for (var i = 0; i < customizationOptions.length; i++) {
        // if (customizationOptions[i].title) {
        //     if (customizationOptions[i].title.length < 3) {
        //         toast.error("Customization title must be 3 characters or more.", { id: "toast" });
        //         return false;
        //     }
        // }
        // if (customizationOptions[i].price < 0) {
        //     toast.error("Price must not be negative.", { id: "toast" });
        //     return false;
        // }

        if (isEmpty(customizationOptions[i].title)) {
          toast.error("Customization title must not be empty.", {
            id: "toast",
          });
          return false;
        } else if (customizationOptions[i].title.length < 3) {
          toast.error("Customization title must be 3 or more characters.", {
            id: "toast",
          });
          return false;
        } else if (isEmpty(customizationOptions[i].price)) {
          toast.error("Customization Price must not be empty.", {
            id: "toast",
          });
          return false;
        } else if (customizationOptions[i].price < 0) {
          toast.error("Price must not be negative.", { id: "toast" });
          return false;
        }
      }
    }
    if (customizationOptions.length !== 0) {
      return true;
    }
    return true;
  };

  //Submit Item Customization Form
  const handleSubmit = async () => {
    try {
      var selectionNumberObj = {
        minimumSelection: 0,
        maximumSelection: 0,
      };
      if (record.customizationType.key === "SingleSelection") {
        selectionNumberObj = {
          minimumSelection: 1,
          maximumSelection: 1,
        };
      } else if (record.customizationType.key === "MultiSelection") {
        selectionNumberObj = {
          minimumSelection: 1,
          maximumSelection: -1,
        };
      } else {
        selectionNumberObj = {
          minimumSelection: record.selectionNumber,
          maximumSelection: record.selectionNumber,
        };
      }
      let recordObj = {
        ...record,
        ...selectionNumberObj,
        sortOrder: parseInt(record.sortOrder),
        // restaurantUuid: record.restaurantUuid.key, >>> Todo
        customizationType: record.customizationType.key,
        customizationOptions: customizationOptions,
      };

      if (!checkInputValidation(recordObj)) {
        return;
      }

      if (!checkCustomizationValidation()) {
        return;
      }

      delete recordObj.selectionNumber;
      if (!recordID || recordID === "") {
        callPostApi(
          MODAL_LOADER,
          Save_Restaurant_Item_Customization_Post,
          recordObj,
          {},
          (response) => {
            if (response.errorCode === API_SUCCESS) {
              toast.success(response.message, {id: "toast"});
              hideModal();
              handleRefresh();
            } else {
              toast.error(response.message, {id: "toast"});
            }
          }
        );
      } else {
        const rUrl = ownedItem
          ? Update_Restaurant_Item_Customization_Put
          : Update_Rest_Menu_Restaurant_Item_Customization_Put;
        callPutApi(
          MODAL_LOADER,
          rUrl.replaceAll("{recordID}", recordID),
          recordObj,
          {},
          (response) => {
            if (response.errorCode === API_SUCCESS) {
              toast.success(response.message, {id: "toast"});
              hideModal();
              handleRefresh();
            } else {
              toast.error(response.message, {id: "toast"});
            }
          }
        );
      }
    } catch (error) {
      return;
    }
  };

  return (
    <ModalWrapper
      show={show}
      hide={hideModal}
      backdrop="static"
      header={`${recordID ? "Update" : "Add"} Item Customization`}
      handleSubmit={handleSubmit}
    >
      <fieldset>
        <legend>Basic Details</legend>
        <div className="form-group row align-items-center">
          <div className="col-lg-6 my-2">
            <label> Title *</label>
            <input
              disabled={!ownedItem}
              type="text"
              className="form-control input-default"
              id="title"
              onChange={handleTextChange}
              value={record.title}
            />
          </div>
          {/* <div className="col-lg-4 my-2">
                        <label> Sort Order *</label>
                        <input type="number" className="form-control input-default" id="sortOrder" onChange={handleTextChange} value={record.sortOrder} />
                    </div> */}

          {/* Todo */}
          {/* <div className="col-lg-4 my-2">
                        <label>Restaurant *</label>
                        <Select options={restaurantKeyValuePairs} value={record.restaurantUuid} onChange={(e) => handleSelectChange(e, "restaurantUuid")} />
                    </div> */}
          <div className="col-lg-6 my-2">
            <label>Customization Type *</label>
            <Select
              isDisabled={!ownedItem}
              options={customizationKeyValuePairs}
              value={record.customizationType}
              onChange={(e) => handleSelectChange(e, "customizationType")}
            />
          </div>
          {record.customizationType?.key === "FixedSelection" && (
            <div className="col-lg-6 my-2">
              <label> Selection Number*</label>
              <input
                disabled={!ownedItem}
                type="number"
                className="form-control input-default"
                id="selectionNumber"
                onChange={handleTextChange}
                value={record.selectionNumber}
              />
            </div>
          )}
          <div
            className={`col-lg-${
              record.customizationType?.key === "FixedSelection" ? 6 : 12
            } my-2`}
          >
            <label> Description </label>
            <textarea
              disabled={!ownedItem}
              className="form-control input-default"
              id="description"
              cols="30"
              rows="2"
              onChange={handleTextChange}
              value={record.description}
            />
          </div>
        </div>
      </fieldset>

      <fieldset className="my-3">
        <legend>Customization Options</legend>
        {customizationOptions.length !== 0 &&
          customizationOptions.map((customizeOption, i) => (
            <div className="my-3" key={i}>
              <div className="row">
                <div className={`col-lg-${ownedItem ? 11 : 12}`}>
                  <div className="row">
                    <div className="col-2 customization-options-images">
                      <MultiImageSelector
                        ownedItem={ownedItem}
                        selectedImage={customizeOption.iconRefId}
                        index={i}
                        handleImageSelect={handleImageChange}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        className="form-control input-default"
                        placeholder="Title"
                        id="title"
                        disabled={!ownedItem}
                        onChange={(e) =>
                          handleTextChange(e, "customizationOptions", i)
                        }
                        value={customizeOption.title}
                      />
                    </div>
                    <div className={`col-${ownedItem ? 4 : 2}`}>
                      <div className="input-group mb-3">
                        <input
                          type="number"
                          className="form-control input-default"
                          placeholder="Price"
                          id="price"
                          disabled={!ownedItem && !customizeOption.active}
                          onChange={(e) =>
                            handleTextChange(e, "customizationOptions", i)
                          }
                          value={customizeOption.price}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text bg-red">
                            {currencyDetail?.currencySymbol}
                          </span>
                        </div>
                      </div>
                    </div>
                    {!ownedItem && (
                      <div className="col-lg-2">
                        <input
                          type="checkbox"
                          className="input-default"
                          id="active"
                          checked={customizeOption.active}
                          onChange={(e) =>
                            handleTextChange(e, "customizationOptions", i)
                          }
                        />
                        <label htmlFor="active" className="ms-2">
                          Active
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                {ownedItem && (
                  <div className="col-lg-1">
                    <Button onClick={(e) => handleRemoveOption(i)}>
                      <i className="bx bx-trash" />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ))}
        {ownedItem && (
          <Button onClick={handleAddMoreCustomizeOptions}>
            {" "}
            + Add New Row
          </Button>
        )}
      </fieldset>
    </ModalWrapper>
  );
};

export default RestaurantItemCustomizationAddEdit;
